import { createFileRoute, Outlet, redirect, useLocation } from "@tanstack/react-router";
import { Suspense } from "react";
import { sessionQuery } from "@/api/session";
import { Spinner } from "@/components/ui/misc";
import { noindexHead } from "@/features/marketing/seo";
import { t } from "@/i18n";
import { AppShell } from "@/components/layout/app-shell";

/** Everything under /app requires a session. */
export const Route = createFileRoute("/app")({
  head: () => noindexHead(t("marketing.seo.app")),
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (!session) throw redirect({ to: "/login", search: { redirect: location.href } });
    return { session };
  },
  component: AppLayout,
});

function AppLayout() {
  const print = useLocation({ select: (location) => /^\/app\/w\/[^/]+\/print\//.test(location.pathname) });
  const content = (
    <Suspense fallback={<Spinner className="min-h-dvh items-center" />}>
      <Outlet />
    </Suspense>
  );
  return print ? content : <AppShell>{content}</AppShell>;
}
